import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { AntdModule } from "../antd.module";
import { LoaderComponent } from "./components/loader/loader.component";
import { RolesDirective } from "./directives/roles/roles.directive";
import { TjBackButtonDirective } from "./directives/tj-back-button/tj-back-button.directive";
import { TjSelectComponent } from "./form/tj-select/tj-select.component";
import { TjSwitchComponent } from "./form/tj-switch/tj-switch.component";
import { ToolsService } from "./services/tools/tools.service";
import { FooterComponent } from "./structure/footer/footer.component";
import { SidebarHeaderComponent } from "./structure/sidebar-header/sidebar-header.component";
import { DecimalToCommaPipe } from "./pipes/decimal-to-comma.pipe";

const directives = [TjBackButtonDirective, RolesDirective];

const importModules = [
  CommonModule,
  AntdModule,
  RouterModule,
  FormsModule,
  ReactiveFormsModule
];

const services = [ToolsService];

const sharedComponents = [
  FooterComponent,
  SidebarHeaderComponent,
  TjSelectComponent,
  TjSwitchComponent,
  LoaderComponent,
];

@NgModule({
  declarations: [...sharedComponents, ...directives, DecimalToCommaPipe],
  imports: [...importModules],
  providers: [...services],
  exports: [
    ...sharedComponents,
    ...directives,
    ...importModules,
    DecimalToCommaPipe,
  ],
})
export class SharedModule { }
